import { MessageOutlined } from '@ant-design/icons';

import KakaoMessagePage from '../pages/KakaoMessagePage';

import { SiteMap } from './index';

export const messageRoutes: SiteMap = {
  message: {
    title: '메시지 발송 결과',
    page: KakaoMessagePage,
    icon: <MessageOutlined />,
    key: '/message',
    children: [
      {
        label: '알림톡',
        icon: null,
        key: '/message/alimtalk/invoice',
      },
      {
        label: '친구톡',
        icon: null,
        key: '/message/friendtalk/daily-price-list',
      },
      {
        label: '문자',
        icon: null,
        key: '/message/sms',
      },
    ],
  },
};
